import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-kritis-igd`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/monitoring-kritis-igd/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/monitoring-kritis-igd", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-kritis-igd/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/monitoring-kritis-igd/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// TTV
async function addTtv(monitoringId: number, data: any) {
  const response = await http
    .postData(`/monitoring-kritis-igd/${monitoringId}/ttv`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateTtv(monitoringId: number, ttvId: number, data: any) {
  const response = await http
    .putData(`/monitoring-kritis-igd/${monitoringId}/ttv/${ttvId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteTtv(monitoringId: number, ttvId: number) {
  const response = await http
    .deleteData(`/monitoring-kritis-igd/${monitoringId}/ttv/${ttvId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Intervensi
async function addIntervensi(monitoringId: number, data: any) {
  const response = await http
    .postData(`/monitoring-kritis-igd/${monitoringId}/intervensi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateIntervensi(monitoringId: number, intervensiId: number, data: any) {
  const response = await http
    .putData(`/monitoring-kritis-igd/${monitoringId}/intervensi/${intervensiId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteIntervensi(monitoringId: number, intervensiId: number) {
  const response = await http
    .deleteData(`/monitoring-kritis-igd/${monitoringId}/intervensi/${intervensiId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Medikasi
async function addMedikasi(monitoringId: number, data: any) {
  const response = await http
    .postData(`/monitoring-kritis-igd/${monitoringId}/medikasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateMedikasi(monitoringId: number, medikasiId: number, data: any) {
  const response = await http
    .putData(`/monitoring-kritis-igd/${monitoringId}/medikasi/${medikasiId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteMedikasi(monitoringId: number, medikasiId: number) {
  const response = await http
    .deleteData(`/monitoring-kritis-igd/${monitoringId}/medikasi/${medikasiId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Workflow
async function disposisi(id: number, data: any) {
  const response = await http
    .postData(`/monitoring-kritis-igd/${id}/disposisi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function timeline(id: number) {
  const response = await http
    .getData(`/monitoring-kritis-igd/${id}/timeline`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/monitoring-kritis-igd/${id}/pdf`,
    "_blank"
  );
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  addTtv,
  updateTtv,
  deleteTtv,
  addIntervensi,
  updateIntervensi,
  deleteIntervensi,
  addMedikasi,
  updateMedikasi,
  deleteMedikasi,
  disposisi,
  timeline,
  printPdf,
};
